import { Heading, Text } from '@unistocks/components/text/text';
import React from 'react';
import { HeadingProps, ViewProps } from 'tamagui';
import { Column, Row } from '../layout/flex';

export type SheetHeaderProps = Omit<ViewProps, 'children'> & {
  size?: HeadingProps['size'];
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
};

export const SheetHeader: React.FC<SheetHeaderProps> = ({
  size,
  title,
  subtitle,
  icon,
  iconRight,
  ...props
}) => {
  return (
    <Row
      mx={'$-3'}
      px={'$3'}
      py={'$1'}
      gap={'$2'}
      justifyContent="space-between"
      alignItems={'center'}
      borderBottomWidth={1}
      borderColor={'$borderColor'}
      {...props}
    >
      {icon}
      {title && subtitle ? (
        <Column maxWidth={'80%'} mr={'auto'}>
          <Heading sheet size={size}>
            {title}
          </Heading>
          <Text size={'$3'} color={'$color'} opacity={0.6}>
            {subtitle}
          </Text>
        </Column>
      ) : title ? (
        <Heading size={size} sheet={!size} mr={'auto'}>
          {title}
        </Heading>
      ) : null}
      {iconRight}
    </Row>
  );
};

SheetHeader.displayName = 'SheetHeader';
